import React from 'react';
import styles from '../Header.module.css';
import { PrismicText } from "@prismicio/react";
import { asText } from "@prismicio/client";
export default function HeaderNav(_a) {
    var className = _a.className, data = _a.data;
    var isActive = function (productName, a) {
        return window.location.pathname.includes(productName.toLowerCase());
    };
    return (React.createElement("div", { className: "".concat(styles['nav-item-wrapper'], " ").concat(className || '') }, data && data.map(function (product) { return (React.createElement("a", { href: product.url, className: "".concat(styles['nav-item'], " ").concat(isActive(asText(product.name)) ? styles['nav-item_active'] : '') },
        React.createElement(PrismicText, { field: product.name }))); })));
}
;
//# sourceMappingURL=HeaderNav.js.map